// cspell-checker: disable-next-line
const FONT_PRIMARY = 'Montserrat, sans-serif'; // Google Font

const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightBold: 700,
  fontWeightMedium: 600,
  fontWeightSemiMedium: 500,
  fontWeightRegular: 400,
};

export default typography;
